// 模拟数据，基于数据库结构
import c1 from '@/assets/img/c1.avif'
import c2 from '@/assets/img/c2.avif'
import c3 from '@/assets/img/c3.jpg'
import b1 from '@/assets/img/b1.webp'
import b2 from '@/assets/img/b2.jpg'
import n1 from '@/assets/img/n1.avif'
import n2 from '@/assets/img/n2.avif'
import n3 from '@/assets/img/n3.avif'
import n4 from '@/assets/img/n4.avif'

export const carouselData = [
  {
    id: 1,
    title: '绿色矿山，可持续发展',
    type: 0,
    target_type: 0,
    resource_path: c3,
    css_class: 'slide-2'
  },
  {
    id: 2,
    title: '专注民爆行业，引领安全生产',
    type: 0, // 图片
    resource_path: c2,
    target_type: 0,
    css_class: 'slide-1'
  },
  {
    id: 3,
    title: '科技创新，驱动未来',
    type: 0,
    resource_path: c1,
    target_type: 0,
    css_class: 'slide-3'
  }
];

export const businessData = {
  explosives: {
    title: '民爆业务',
    description: '公司主要专注经营生产民用爆炸物品和提供爆破作业相关的业务，同时拥有民爆行业的生产和施工双资质。目前公司主要业务方向包括民用爆破器材研发、生产、销售；工程爆破设计、施工、爆破技术服务等。',
    history: '公司成立于2003年，前身是中国电力科技控股有限公司。2015年7月注资成功，主营业务领域变更为民爆行业。',
    image: b1
  },
  mining: {
    title: '矿山业务',
    description: '目前集团经营的黄屯硫铁矿矿区项目处于正式商业生产阶段，矿区位于中国安徽省庐江县。黄屯硫铁矿矿区含有的矿藏包括铜矿、金矿、硫铁矿及铁矿石。',
    history: '2020年10月，比优集团收购安徽省金鼎矿业有限公司，延申业务至有色金属及贵金属开采行业。',
    image: b2
  }
};

export const newsData = [
  {
    id: 1,
    title: '比优集团发布2024年度可持续发展报告',
    summary: '集团在ESG领域取得重大突破，绿色矿山建设成效显著...',
    publish_time: '2025-11-28',
    cover_image: n1,
    category: '集团新闻'
  },
  {
    id: 2,
    title: '安徽金鼎矿业技术改造项目顺利竣工',
    summary: '通过引入智能化设备，矿区生产效率提升30%，安全系数大幅提高...',
    publish_time: '2025-11-15',
    cover_image: n2,
    category: '业务动态'
  },
  {
    id: 3,
    title: '集团荣获"国家级高新技术企业"认定',
    summary: '标志着公司在民爆技术研发领域达到国内领先水平...',
    publish_time: '2025-10-20',
    cover_image: n3,
    category: '荣誉奖项'
  },
  {
    id: 4,
    title: '2025年第三季度财报发布：净利润同比增长15%',
    summary: '民爆与矿山双轮驱动，业绩稳步增长，现金流充裕...',
    publish_time: '2025-10-10',
    cover_image: n4,
    category: '投资者关系'
  }
];

export const reportsData = [
  {
    id: 1,
    title: '2024年年度报告',
    type: '年报',
    date: '2025-03-30',
    file_type: 'PDF'
  },
  {
    id: 2,
    title: '2024年环境、社会及管治(ESG)报告',
    type: 'ESG报告',
    date: '2025-03-30',
    file_type: 'PDF'
  },
  {
    id: 3,
    title: '2025年中期报告',
    type: '半年报',
    date: '2025-08-30',
    file_type: 'PDF'
  },
  {
    id: 4,
    title: '关于收购安徽金鼎矿业的进展公告',
    type: '公告',
    date: '2025-09-15',
    file_type: 'PDF'
  }
];

export const menuData = [
  {
    name: '首页',
    path: '/',
    i18nKey: 'menu.home'
  },
  {
    name: '关于比优',
    path: '/about',
    i18nKey: 'menu.about',
    children: [
      {
        name: '集团介绍',
        path: '/about',
        i18nKey: 'menu.introduction'
      },
      {
        name: '公司高管',
        path: '/about/executives',
        i18nKey: 'menu.executives'
      },
      {
        name: '发展历程',
        path: '/about/group_events',
        i18nKey: 'menu.group_events'
      },
      {
        name: '集团荣誉',
        path: '/about/honors',
        i18nKey: 'menu.honors'
      },
      {
        name: '集团视频',
        path: '/about/video',
        i18nKey: 'menu.company_video'
      },
    ]
  },
  {
    name: '主营业务',
    path: '/business/mining',
    i18nKey: 'menu.main_business',
    children: [
      {
        name: '矿产开发',
        path: '/business/mining',
        i18nKey: 'menu.mining'
      },
      {
        name: '矿山建设',
        path: '/business/mine-construction',
        i18nKey: 'menu.mine-construction'
      },
      {
        name: '民爆生产',
        path: '/business/explosives',
        i18nKey: 'menu.explosives'
      },
    ]
  },
  {
    name: '新闻中心',
    path: '/news',
    i18nKey: 'menu.news'
  },
  {
    name: '投资者关系',
    path: '/notice',
    i18nKey: 'menu.investors'
  },
  {
    name: '联系我们',
    path: '/contact',
    i18nKey: 'menu.contact'
  }
];
